import { LOCATION_CHANGED } from '../ducks/routing.duck';

// Create a Redux middleware from the given analytics handlers. Each
// handler should have the following methods:
//
// - trackPageView(canonicalPath, previousPath): called when the URL is changed
export const createMiddleware = handlers => store => next => action => {
  const { type, payload } = action;

  if (type === LOCATION_CHANGED) {
    const previousPath = store?.getState()?.routing?.currentCanonicalPath;
    const { canonicalPath } = payload;
    handlers.forEach(handler => {
      try {
        if (handler && typeof handler.trackPageView === 'function') {
          handler.trackPageView(canonicalPath, previousPath);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[analytics] trackPageView failed:', e);
      }
    });
  }

  // Wrap downstream so a throw in any reducer / subscription handler (e.g. a
  // connected component's mapStateToProps blowing up on bad entity data) does
  // NOT escape this middleware and tear down the React tree. Logged once with
  // the action type so the cause is visible in the console.
  try {
    return next(action);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[analytics] downstream dispatch threw', { type, err });
    return undefined;
  }
};
